export const systemErrorsMock = [
  {
    id: '550e8400-e29b-41d4-a716-446655440000',
    level: 'critical',
    source: 'evolution-webhook',
    message: 'Webhook não respondeu em 30s — instância wzap-prod-01',
    details: 'Timeout ao processar webhook de mensagem recebida. Instância Evolution API na porta 8080. Verificar se o container está rodando.',
    user_id: null,
    company_id: null,
    ip_address: '192.168.1.105',
    user_agent: 'Evolution-API/1.8.0',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T14:23:10Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    level: 'error',
    source: 'send-whatsapp-message',
    message: 'Falha ao enviar mensagem para +55 11 98765-4321',
    details: 'Erro 403: número não está na lista de contatos permitidos. Campanha "Black Friday 2026" — ID 2341.',
    user_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    company_id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
    ip_address: '10.0.0.45',
    user_agent: 'Mozilla/5.0',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T13:45:22Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    level: 'error',
    source: 'mercadopago-webhook',
    message: 'Assinatura do webhook inválida',
    details: 'Payload recebido não corresponde à assinatura HMAC-SHA256. Possível tentativa de spoofing. Origem IP: 203.0.113.45.',
    user_id: null,
    company_id: null,
    ip_address: '203.0.113.45',
    user_agent: 'MP-WebHook/2.0',
    resolved: true,
    resolved_at: '2026-08-05T12:10:00Z',
    resolved_by: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    created_at: '2026-08-05T11:30:15Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    level: 'warning',
    source: 'process-queue',
    message: 'Fila de envio acumulou 1.247 mensagens pendentes',
    details: 'Processamento de fila está lento. Média de processamento: 45 msg/min. Verificar limites de rate da Evolution API.',
    user_id: null,
    company_id: null,
    ip_address: '127.0.0.1',
    user_agent: 'QueueWorker/1.0',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T10:15:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    level: 'error',
    source: 'supabase-auth',
    message: 'Falha na renovação de token JWT',
    details: 'Erro 401: token expirado e não foi possível renovar. Usuário redirecionado para login. Session ID: sess_abc123.',
    user_id: 'd4e5f6a7-b8c9-0123-defa-456789012345',
    company_id: null,
    ip_address: '172.16.0.23',
    user_agent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    resolved: true,
    resolved_at: '2026-08-05T09:45:00Z',
    resolved_by: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    created_at: '2026-08-05T09:30:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    level: 'warning',
    source: 'backup-worker',
    message: 'Backup automático demorou 12min (limite: 5min)',
    details: 'Backup do banco de dados completou com sucesso, mas excedeu o tempo esperado. Tamanho do dump: 847MB. Revisar política de retenção.',
    user_id: null,
    company_id: null,
    ip_address: '127.0.0.1',
    user_agent: 'BackupAgent/3.2',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T08:00:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440006',
    level: 'critical',
    source: 'stripe-webhook',
    message: 'Stripe webhook retornou 500 — pagamento não confirmado',
    details: 'Evento invoice.payment_succeeded não foi processado. Cliente: Ricardo Almeida (cus_abc123). Pagamento: $97.00. Reprocessar manualmente.',
    user_id: null,
    company_id: null,
    ip_address: '54.187.174.169',
    user_agent: 'Stripe/1.0 (+https://stripe.com/docs/webhooks)',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T07:15:30Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440007',
    level: 'info',
    source: 'admin-manage-users',
    message: 'Tentativa de criação de usuário com email duplicado',
    details: 'Email "mariana.costa@email.com" já existe no sistema. Tentativa bloqueada. ID do solicitante: admin_001.',
    user_id: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    company_id: null,
    ip_address: '201.45.123.67',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
    resolved: true,
    resolved_at: '2026-08-05T06:50:00Z',
    resolved_by: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    created_at: '2026-08-05T06:45:10Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440008',
    level: 'error',
    source: 'export-report',
    message: 'Falha ao gerar relatório PDF — memória insuficiente',
    details: 'Edge function "export-report" atingiu limite de memória (256MB) ao processar campanha com 45.000 contatos. Recomendado: dividir em lotes.',
    user_id: 'e5f6a7b8-c9d0-1234-efab-567890123456',
    company_id: 'f6a7b8c9-d0e1-2345-fabc-678901234567',
    ip_address: '10.0.0.12',
    user_agent: 'Mozilla/5.0',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T05:20:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440009',
    level: 'warning',
    source: 'evolution-api',
    message: 'Conexão WhatsApp instável — reconectando',
    details: 'Instância "wzap-cliente-42" perdeu conexão com o WhatsApp. Reconexão automática iniciada. Tentativa 3 de 5.',
    user_id: null,
    company_id: 'a7b8c9d0-e1f2-3456-abcd-789012345678',
    ip_address: '192.168.2.88',
    user_agent: 'Evolution-API/1.8.0',
    resolved: true,
    resolved_at: '2026-08-05T04:55:00Z',
    resolved_by: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    created_at: '2026-08-05T04:30:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440010',
    level: 'critical',
    source: 'database-connection',
    message: 'Timeout na conexão com Supabase — queries falhando',
    details: 'Pool de conexões esgotado. 150 conexões simultâneas ativas. Reiniciando pool. Queries afetadas: dashboard stats, queue jobs.',
    user_id: null,
    company_id: null,
    ip_address: '127.0.0.1',
    user_agent: 'Supabase-Client/2.0',
    resolved: false,
    resolved_at: null,
    resolved_by: null,
    created_at: '2026-08-05T03:10:00Z',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440011',
    level: 'error',
    source: 'smtp-config',
    message: 'Servidor SMTP rejeitou autenticação',
    details: 'Credenciais SMTP inválidas ou expiradas. Host: smtp.gmail.com:587. Usuário: noreply@wzap.pro. Verificar senha de app.',
    user_id: null,
    company_id: null,
    ip_address: '127.0.0.1',
    user_agent: 'NodeMailer/6.9',
    resolved: true,
    resolved_at: '2026-08-04T22:30:00Z',
    resolved_by: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    created_at: '2026-08-04T22:00:00Z',
  },
];